import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { FileExchangeService } from 'types/exchangeService';
import { IdsFileLocation } from 'types/pdfService';
import { COMMON_URLS } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

export default class ReadyToSendPdfsStore {
  rootStore: RootStore;
  loading = false;
  exchangeReadyFiles: IdsFileLocation[] = [];
  selectedFile: IdsFileLocation | null = null;
  isModalOpen = false;

  private setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  public closeModal(): void {
    this.isModalOpen = false;
    this.selectedFile = null;
  }

  public openWarningModal(file: IdsFileLocation): void {
    this.isModalOpen = true;
    this.selectedFile = file;
  }

  public async getExchangeReadyFiles(sponsorId: string): Promise<void> {
    this.setLoading(true);
    const res = await this.rootStore.pdfStore.getExchangeReadyFiles(sponsorId);
    runInAction(() => {
      this.exchangeReadyFiles = res;
      this.setLoading(false);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public buildFileLink(id: string): string {
    return `https://${COMMON_URLS.api}/pdf/Prod/download/${id}`;
  }

  public async sendFile(fileId: string, sponsorId: string): Promise<void> {
    this.setLoading(true);
    await this.rootStore.exchangeStore
      .sendFile(fileId, sponsorId, FileExchangeService.PDF)
      .then((res) => {
        if (res.data?.sendFile?.id) {
          this.rootStore.filesTrackingController.showToast(
            'The file has been successfully sent.',
            ToastColorTypes.SUCCESS,
          );
        } else {
          this.rootStore.filesTrackingController.showToast(
            'An issue has occurred while attempting to send the file. Please try again later.',
            ToastColorTypes.WARNING,
          );
        }
        this.setLoading(false);
      })
      .catch(() => {
        this.rootStore.filesTrackingController.showToast(
          'An issue has occurred while attempting to send the file. Please try again later.',
          ToastColorTypes.WARNING,
        );
        this.setLoading(false);
      });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
